function initCarousel(section) {
  if (section.dataset.carouselReady) return;
  section.dataset.carouselReady = 'true';

  var grid    = section.querySelector('[data-carousel-grid]');
  var btnPrev = section.querySelector('[data-carousel-prev]');
  var btnNext = section.querySelector('[data-carousel-next]');

  if (!grid || !btnPrev || !btnNext) return;

  var autoplayEnabled = section.dataset.autoplay === 'true';
  var autoplaySpeed   = parseInt(section.dataset.autoplaySpeed, 10) || 5;
  var autoplayTimer   = null;

  function needsCarousel() {
    return grid.scrollWidth > grid.clientWidth + 1;
  }

  function updateArrows() {
    if (!needsCarousel()) {
      btnPrev.hidden = true;
      btnNext.hidden = true;
      return;
    }
    btnPrev.hidden = false;
    btnNext.hidden = false;
    btnPrev.disabled = grid.scrollLeft <= 1;
    btnNext.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
  }

  function getScrollAmount() {
    var card = grid.firstElementChild;
    if (!card) return grid.clientWidth;
    return card.offsetWidth + (parseFloat(window.getComputedStyle(grid).gap) || 16);
  }

  function startAutoplay() {
    if (!autoplayEnabled || !needsCarousel()) return;
    stopAutoplay();
    autoplayTimer = setInterval(function() {
      var atEnd = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
      grid.scrollTo({
        left: atEnd ? 0 : grid.scrollLeft + getScrollAmount(),
        behavior: 'smooth'
      });
    }, autoplaySpeed * 1000);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  btnPrev.addEventListener('click', function() {
    grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  btnNext.addEventListener('click', function() {
    grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateArrows, { passive: true });
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateArrows, 150);
  });

  updateArrows();
  startAutoplay();
}

document.querySelectorAll('[data-carousel-section]').forEach(initCarousel);